// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--3vba1","icon":"styles-module--icon--k4RPV","right":"styles-module--right--2NasT","customMedia":{},"customProperties":{},"customSelectors":{}};